<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">
    {{'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.FORM_TITLE' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <app-transit-request #TransitRequest [IsAdminMode]="true"></app-transit-request>
  </div>

  <div *ngIf="baseRequestId">
    <form [formGroup]="MarineEstimatePenaltyForm">
      <div class="form-container">
        <div class="form-section">




          <h4 class="section-title" style="margin-top: 20px;">
            {{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_ESTIMATE' | translate }}</h4>

          <!-- ==========================================
                         PENALTY TYPE LABEL
          ========================================== -->
          <div class="form-section">
            <div class="form-container">
              <div class="alert alert-info" role="alert" style="margin-bottom: 20px; margin-top: 0;">
                <strong>{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_TYPE' | translate }}:</strong>
                <span *ngIf="editFlag" class="ms-2">
                  {{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_TYPE_POSTPONE' | translate }}
                </span>
                <span *ngIf="cancelFlage" class="ms-2">
                  {{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_TYPE_CANCEL' | translate }}
                </span>
                <span *ngIf="LateBookingFlag" class="ms-2">
                  {{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_TYPE_LATE_BOOKING' | translate }}
                </span>
              </div>
            </div>
          </div>
          <!-- ==========================================
               POSTPONE PENALTY (editFlag = true)
               Show: Old Transit Date, New Transit Date, Action Date + Time
               ========================================== -->
          <ng-container *ngIf="editFlag">
            <div class="form-group">
              <label for="OldTransitDate">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.OLD_TRANSIT_DATE' |
                translate}}</label>
              <input class="form-control" #oldTransitDatepicker="bsDatepicker" bsDatepicker
                formControlName="OldTransitDate" id="OldTransitDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}"
                autocomplete="off" disabled />
            </div>

            <div class="form-group">
              <label for="NewTransitDate">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.NEW_TRANSIT_DATE' |
                translate}}</label>
              <input class="form-control" #newTransitDatepicker="bsDatepicker" bsDatepicker
                formControlName="NewTransitDate" id="NewTransitDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}"
                autocomplete="off" disabled />
            </div>

            <div class="form-group">
              <label for="ActionDateModified">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.ACTION_DATE_MODIFIED' |
                translate}}</label>
              <input class="form-control" #actionDatepicker="bsDatepicker" bsDatepicker
                formControlName="ActionDateModified" id="ActionDateModified"
                [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}" autocomplete="off" disabled />
              <timepicker id="ActionTimeModified" formControlName="ActionTimeModified" [hourStep]="1" [minuteStep]="1"
                disabled>
              </timepicker>
            </div>
          </ng-container>

          <!-- ==========================================
               CANCEL PENALTY (cancelFlage = true)
               Show: Old Transit Date, Cancel Date, Action Date + Time
               ========================================== -->
          <ng-container *ngIf="cancelFlage">
            <div class="form-group">
              <label for="OldTransitDate">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.OLD_TRANSIT_DATE' |
                translate}}</label>
              <input class="form-control" #oldTransitDatepicker="bsDatepicker" bsDatepicker
                formControlName="OldTransitDate" id="OldTransitDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}"
                autocomplete="off" disabled />
            </div>

            <div class="form-group">
              <label for="ActionDateModified">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.ACTION_DATE_MODIFIED' |
                translate}}</label>
              <input class="form-control" #actionDatepicker="bsDatepicker" bsDatepicker
                formControlName="ActionDateModified" id="ActionDateModified"
                [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}" autocomplete="off" disabled />
              <timepicker id="ActionTimeModified" formControlName="ActionTimeModified" [hourStep]="1" [minuteStep]="1"
                disabled>
              </timepicker>
            </div>
          </ng-container>

          <!-- ==========================================
               LATE BOOKING PENALTY (LateBookingFlag = true)
               Show: Transit Date, Action Date + Time
               ========================================== -->
          <ng-container *ngIf="LateBookingFlag">
            <div class="form-group">
              <label for="BookingDate">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.OLD_TRANSIT_DATE' |
                translate}}</label>
              <input class="form-control" #bookingDatepicker="bsDatepicker" bsDatepicker formControlName="BookingDate"
                id="BookingDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}" autocomplete="off" disabled />
            </div>

            <div class="form-group">
              <label for="ActionDateModified">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.ACTION_DATE_MODIFIED' |
                translate}}</label>
              <input class="form-control" #actionDatepicker="bsDatepicker" bsDatepicker
                formControlName="ActionDateModified" id="ActionDateModified"
                [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}" autocomplete="off" disabled />
              <timepicker id="ActionTimeModified" formControlName="ActionTimeModified" [hourStep]="1" [minuteStep]="1"
                disabled>
              </timepicker>
            </div>
          </ng-container>

          <!-- ==========================================
               COMMON FIELDS FOR ALL PENALTY TYPES
               ========================================== -->
          <div class="form-group">
            <label for="PenaltyValue">{{'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_VALUE' |
              translate}}</label>
            <span class="red">*</span>
            <input formControlName="PenaltyValue" id="PenaltyValue" name="PenaltyValue" class="form-control" />
            <div *ngIf="submitted || (f.PenaltyValue?.dirty && f.PenaltyValue?.errors)" class="red ">
              <div *ngIf="f.PenaltyValue?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.PenaltyValue?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
              <div *ngIf="f.PenaltyValue?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="f.PenaltyValue?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_150_ERROR' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="PenaltyClauses">{{ 'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_CLAUSES' |
              translate}}</label>
            <span class="red">*</span>
            <select formControlName="PenaltyClauses" class="form-control" id="PenaltyClauses">
              <option [value]="''" selected>
                {{'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PLEASE_SELECT_A_PENALTY_CLAUSES' | translate}}
              </option>
              <ng-container *ngFor="let clause of PenaltyClausesList">
                <option *ngIf="displayedLang==Languages.English" [value]="clause.Id">
                  {{clause.NameEN}}
                </option>
                <option *ngIf="displayedLang==Languages.Arabic" [value]="clause.Id">
                  {{clause.NameAR}}
                </option>
              </ng-container>
            </select>
            <div *ngIf="submitted || (f.PenaltyClauses?.dirty && f.PenaltyClauses?.errors)" class="red">
              <div *ngIf="f.PenaltyClauses?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            </div>
          </div>

          <div class="form-group">
            <label for="PenaltyReason">{{'ADMIN_USER.TRANSIT.ESTIMATE_PENALTY_FORM.PENALTY_REASON' | translate}}
            </label>
            <textarea id="PenaltyReason" formControlName="PenaltyReason" class="form-control"></textarea>
            <div *ngIf="submitted || (f.PenaltyReason?.dirty && f.PenaltyReason?.errors)" class="red">
              <div *ngIf="f.PenaltyReason?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="formMode == FormMode.Add" class="form-group">
          <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
            'FRONT_USER.SUBMIT' | translate}}</button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>